import { getTimeString } from '../../../Utils';

const DelayedStopName = ({ classes, stopData, statusClass, status }) => {
  const delayDisplayName = stopData?.routeLevelDelayStopName;
  return (
    <div className={classes.delayedStop}>
      <div className={classes.detailContainer}>
        <div>
          {`${delayDisplayName} | ${getTimeString(stopData.arrivalTime)} - ${getTimeString(
            stopData.departureTime
          )}`}
        </div>
        <div className={`${classes.stopStatus} ${statusClass}`}>{status}</div>
      </div>
    </div>
  );
};

export default DelayedStopName;
